module.exports = "/fonts/alarm.ttf?2803116d50a5be32e5435aba7d4bb941";